// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'Outfit', 'Outfit Fallback'","fontStyle":"normal"},"className":"__className_71687e"};